import { Folder } from "Models/folder";

const VIDEO_FOLDER_NAME = "videos";
const VIDEO_SURVEY_NAME = "video survey";

export const filterVideoSurveyFolder = (folders?: Folder[]): Folder[] => {
  if (!folders?.length) return [];

  return folders.map((folder) => {
    if (folder.name?.toLowerCase() !== VIDEO_FOLDER_NAME) {
      return folder;
    }

    const filteredSubFolders =
      folder.folders?.filter((subFolder) => {
        if (subFolder.name?.toLowerCase() !== VIDEO_SURVEY_NAME) {
          return true;
        }

        return Array.isArray(subFolder.files) && subFolder.files.length > 0;
      }) ?? [];

    return {
      ...folder,
      folders: filteredSubFolders,
    };
  });
};
